<form [formGroup]="form" formSanitizer (ngSubmit)="onSave()">
  <div mat-dialog-title>
    <h1 *ngIf="data.mode === 'add'">Create cost plan</h1>
    <h1 *ngIf="data.mode === 'edit'">Edit cost plan name</h1>
  </div>
  <mat-dialog-content flexLayout="row">
    <mat-form-field flex>
      <mat-label>Plan name</mat-label>
      <input title="Plan name" matInput required type="text" formControlName="planName" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions flexLayoutAlign="end center">
    <button type="button" mat-flat-button (click)="onCancel()">Cancel</button>
    <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">
      Commit
    </button>
  </mat-dialog-actions>
</form>
